import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { components } from 'react-select';
import { ReactComponent as Arrow } from '../../../../media/arrows/Arrow.svg';

export const Validation = styled.div`
  display: ${(props) => (props.error ? 'block' : 'none')};
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
`;

export const IndicatorSeparator = () => null;
export const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Arrow height="10" width="10" className="custom-arrow" />
    </components.DropdownIndicator>
  );
};

export const changeAdressSelectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderRadius: '1rem',
    fontFamily: `'Lato-Light', sans-serif`,
    fontWeight: '300',
    fontSize: '1.3rem',
    lineHeight: '1.8rem',
    cursor: state.isDisabled ? 'not-allowed' : 'auto',
    '.custom-arrow': {
      rotate: state.menuIsOpen ? '180deg' : '0deg',
    },
    ...(state.menuIsOpen
      ? {
          borderBottomRightRadius: 'revert',
          borderBottomLeftRadius: 'revert',
        }
      : {}),
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    marginTop: '-1px',
    border: `1px solid ${colors.lightGray21} !important`,
    boxShadow: 'none',
    fontFamily: `'Lato-Light', sans-serif`,
    fontWeight: '300',
    fontSize: '1.3rem',
    lineHeight: '1.8rem',
  }),
};

export const Input = styled.input`
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  background-image: none;
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  background-color: #ffffff;
  border: 0.1rem solid ${(props) => (props.error ? '#f00' : '#CECECE')};
  border-radius: 1rem;
  color: #1c1c1c;
  font-size: 1.3rem;
  line-height: 1.8rem;
`;

export const Page = styled.div`
  margin: 4rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Label = styled.label`
  padding: 0.5em 2em 0.5em 0.5em;
  flex: 1;
  text-align: right;
  color: #7f7f7f;
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  font-weight: 700;
`;

export const FormField = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
`;

export const FormItem = styled.div`
  flex: 4;
`;
